const actions = {
  GET_AI_CHECK_LIST_REQUEST: "AI_CHECK/GET_LIST_REQUEST",
  GET_AI_CHECK_LIST_SUCCESS: "AI_CHECK/GET_LIST_SUCCESS",
  GET_AI_CHECK_LIST_ERROR: "AI_CHECK/GET_LIST_ERROR",

  CREATE_AI_CHECK_REQUEST: "AI_CHECK/CREATE_REQUEST",
  CREATE_AI_CHECK_SUCCESS: "AI_CHECK/CREATE_SUCCESS",
  CREATE_AI_CHECK_ERROR: "AI_CHECK/CREATE_ERROR",

  NORMALIZE_AI_CHECK_REQUEST: "AI_CHECK/NORMALIZE_REQUEST",
  NORMALIZE_AI_CHECK_SUCCESS: "AI_CHECK/NORMALIZE_SUCCESS",
  NORMALIZE_AI_CHECK_ERROR: "AI_CHECK/NORMALIZE_ERROR",

  getList: (payload) => ({
    type: actions.GET_AI_CHECK_LIST_REQUEST,
    payload,
  }),

  create: (payload) => ({
    type: actions.CREATE_AI_CHECK_REQUEST,
    payload,
  }),

  normalize: (payload) => ({
    type: actions.NORMALIZE_AI_CHECK_REQUEST,
    payload,
  }),
};

export default actions;
